import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";

const labs = [
  {
    icon: "ri-graduation-cap-line",
    title: "Education Technology",
    desc: "Exploring new ways to simplify complex administrative processes.",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Business Operations",
    desc: "Developing tools that help organizations automate workflows and work more efficiently.",
  },
  {
    icon: "ri-cpu-line",
    title: "Intelligent Systems",
    desc: "Experimenting with AI-powered products that make digital experiences smarter.",
  },
];

export default function ProductLab() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeader
            dark
            eyebrow="Beyond Client Projects"
            title="We don't just build technology for clients."
            subtitle="We also research and develop proprietary digital products designed to solve complex problems across different industries."
          />
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 px-4 py-2 text-xs font-semibold tracking-[0.15em] text-primary-400 whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            PRODUCT LAB • STEALTH DEVELOPMENT
          </span>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {labs.map((l) => (
            <div
              key={l.title}
              className="rounded-lg border border-background-300 bg-background-100/60 p-7 transition-all duration-300 hover:border-primary-500/40 hover:-translate-y-1"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                <i className={`${l.icon} text-xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                {l.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {l.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <CTAButton to="/contact" variant="outline" icon="ri-arrow-right-line">
            Follow Our Journey
          </CTAButton>
        </div>
      </div>
    </section>
  );
}